import React, { Fragment, useState } from "react";
import { Input, Select, Button, message } from "@cloud/atom-ui";
import { isNumber } from "lodash";
import { handleConfigCallbackUrl, handleUpdateAppConfig } from "../../thunk";
import { CHECK_RESULT } from "../../constant";
import * as css from "./style.m.css";
import { APP_TYPE } from "@src/utils/common";

const { TextArea } = Input;
const { Option } = Select;

export default props => {
  const {
    appId,
    appType,
    onCheckResult,
    checkResult,
    testCallbackUrl,
    onSetJsonParam
  } = props;
  const [actionType, setActionType] = useState("corpAuth"); //事件类型
  const [actionDisabled, setActionDisabled] = useState(false); //执行按钮是否不可勾选
  const [original, setOriginal] = useState(
    JSON.stringify({
      eventType: actionType,
      tenantId: "xxxx",
      timestamp: parseInt(new Date().getTime() / 1000),
      userId: "xxx@yyy"
    })
  ); //参考原文（可修改）
  const [backResult, setBackResult] = useState(""); //返回结果

  //执行 操作
  const doAction = async () => {
    setActionDisabled(true); //只读

    //验证json格式
    try {
      JSON.parse(original);
    } catch {
      message.error("请输入正确的json格式");
      setActionDisabled(false);
      return;
    }
    //发送请求
    setBackResult("测试中请稍后...");
    const insideType = [APP_TYPE.innerapp];
    const testCallbackFn = insideType.includes(+appType)
      ? handleConfigCallbackUrl
      : handleUpdateAppConfig;
    const res = await testCallbackFn({
      type: "test",
      appId,
      jsonParam: original,
      callBackUrl: testCallbackUrl,
      appType
    });
    if (+res?.status === 1) {
      setBackResult(JSON.stringify(res.data || ""));
      onCheckResult(CHECK_RESULT.PASS);
      onSetJsonParam(original);
    } else {
      setBackResult(res.errMsg);
      onCheckResult(CHECK_RESULT.NO_PASS);
    }

    setActionDisabled(false); //编辑
  };

  ///事件类型
  const changeType = value => {
    onCheckResult(null);
    setActionType(value);
    setOriginal(
      JSON.stringify({
        eventType: value,
        tenantId: "xxxx",
        timestamp: parseInt(new Date().getTime() / 1000),
        userId: "xxx@yyy"
      })
    );
  };

  return (
    <Fragment>
      <div className={css["modal-item"]}>
        <span className={css["modal-item-title"]}>事件类型</span>
        <Select
          style={{ width: "325px", flex: "0 0 auto" }}
          onChange={changeType}
          defaultValue="corpAuth"
        >
          <Option value="corpAuth">企业授权事件（corpAuth）</Option>
          <Option value="corpCancelAuth">
            企业解除授权事件（corpCancelAuth）
          </Option>
        </Select>
        <Button
          className={css["modal-item-btn"]}
          onClick={doAction}
          disabled={actionDisabled}
        >
          执行
        </Button>
      </div>
      <div className={css["modal-item"]}>
        <span className={css["modal-item-title"]}>参考原文（可修改）</span>
        <TextArea
          style={{ height: "78px" }}
          value={original}
          className="onlineTest"
          onChange={e => {
            setOriginal(e.target.value);
          }}
        />
      </div>
      <div className={css["modal-item"]}>
        <span className={css["modal-item-title"]}>返回结果</span>
        <TextArea
          style={{ height: "78px", resize: "none", background: "#fff" }}
          value={backResult}
          disabled={true}
          className="onlineTest"
        />
        {isNumber(checkResult) && (
          <span
            className={css.checkResult}
            style={{
              color: checkResult === CHECK_RESULT.NO_PASS ? "red" : "green"
            }}
          >
            {checkResult === CHECK_RESULT.NO_PASS ? "校验不通过" : "校验通过"}
          </span>
        )}
      </div>
    </Fragment>
  );
};
